import React, { useState, useEffect } from 'react'
import ProgressArrowLeftActive from "website/how-to-apply/progress-arrow-left-active.svg"
import ProgressArrowRightActive from "website/how-to-apply/progress-arrow-right-active.svg"
import ProgressArrowLeft from "website/how-to-apply/progress-arrow-left.svg"
import ProgressArrowRight from "website/how-to-apply/progress-arrow-right.svg"
import MobileProgressArrowActive from "website/how-to-apply/mobile-progress-arrow-active.svg"
import MobileProgressArrow from "website/how-to-apply/mobile-progress-arrow.svg"

const ApplyStep = ({ step, header, body, image, direction, mobileImageName }) => {
  const url = "https://calendly.com/yard_au"
  const [active, setActive] = useState('active');
  const [isDesktop, setIsDesktop] = useState(false);
  const [scroll, setScroll] = useState(0);
  const [progressRight, setProgressRight] = useState(<ProgressArrowRight />);
  const [progressLeft, setProgressLeft] = useState(<ProgressArrowLeft />);
  const [mobileProgress, setMobileProgress] = useState(<MobileProgressArrowActive />);
  const resize = () => {
    const displayDesktopVersion = window.innerWidth > 590 ? true : false;
    setIsDesktop(displayDesktopVersion)
  }

  const renderApplyNowButton = 
    <a className={`btn btn-lg btn-green hover-dark-green`} href="/onboarding_funnel/new">
      Apply now
    </a>

  const renderTalkToExpert = (style) => (
    <span className={`btn btn-lg ${style}`} onClick={ () => Calendly.showPopupWidget(url) } >
      Talk to an expert
    </span>
  );

  const renderLeftProgressArrow = (
    <div className="col-lg-7 col-md-6 align-self-end how-to-apply-image-container">
      <img src={gon.assets[image]} className='how-to-apply-image pull-right product-mockups' />
      <div className='progress-icon-container-left'>
        {progressLeft}
      </div>
    </div>
  );

  const renderRightProgressArrow = (
    <div className="col-lg-7 col-md-6 align-self-end how-to-apply-image-container">
      <img src={gon.assets[image]} className='how-to-apply-image product-mockups' />
      <div className='progress-icon-container-right'>
        {progressRight}
      </div>
    </div>
  );

  const applyNowButton = step === '1' ? renderApplyNowButton : null;
  const talkToExpert = step === '2' ? renderTalkToExpert('btn-green hover-dark-green') : null;
  const renderButtons = (style) => { 
    return step === '6' ?
      <div className='step-6-buttons-container'>
        {renderApplyNowButton}
        {renderTalkToExpert(style)}
      </div> : null
  }

  const handleProgressArrow = (min, max, currentStep, direction) => {
    const progressArrow = () => direction === 'left' ? setProgressLeft(<ProgressArrowLeft />): setProgressRight(<ProgressArrowRight />)
    const progressArrowActive = () => direction === 'left' ? setProgressLeft(<ProgressArrowLeftActive />): setProgressRight(<ProgressArrowRightActive />)

    if (scroll >= min && scroll < max && step === currentStep) {
      setActive('active')
      progressArrowActive();
      setMobileProgress(<MobileProgressArrowActive />)
    } else if ((scroll <= min || scroll >= max) && step === currentStep) {
      setActive('')
      progressArrow();
      setMobileProgress(<MobileProgressArrow />)
    }

    if (step === '6') {
      setProgressLeft(<span />)
      setMobileProgress(<span />)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", resize);
    resize();

    if (isDesktop) {
      handleProgressArrow(0, 400, '1', 'right')
      handleProgressArrow(400, 1000, '2', 'left')
      handleProgressArrow(1000, 1500, '3', 'right')
      handleProgressArrow(1500, 2000, '4', 'left')
      handleProgressArrow(2000, 2500, '5', 'right')
      handleProgressArrow(2500, 30000, '6', 'left')
    } else {
      handleProgressArrow(0, 800, '1', 'right')
      handleProgressArrow(800, 1500, '2', 'left')
      handleProgressArrow(1500, 2100, '3', 'right')
      handleProgressArrow(2100, 2700, '4', 'left')
      handleProgressArrow(2700, 3300, '5', 'right')
      handleProgressArrow(3300, 30000, '6', 'left')
    }

    window.addEventListener("scroll", function(event) {
      setScroll(this.scrollY);
    });
  }, [active, scroll])

  return (
    <div className='split-section-image'>
    {isDesktop ? 
      <div className="container">
        <div className={`row ${direction}`}>

          {direction === 'left' && renderLeftProgressArrow }

          <div className="col-lg-5 col-md-6 align-self-center apply-step-text">
            <div className="pt-5 pb-5 p-md-4">
              <div className={`btn step-number ${active} white mb-3`}>
                {step}
              </div>
              <div className="step-header mb-3">
                <h2>{header}</h2>
              </div>
              <p className="step-body mb-5">
                {body}
              </p>
              {applyNowButton}
              {talkToExpert}
              {renderButtons('talk-to-expert-btn-6 btn-line-green hover-light-green')}
            </div>
          </div>

          {direction === 'right' && renderRightProgressArrow }
        </div>
      </div>
      :
      <div className="container">
        <div className="align-self-end how-to-apply-image-container-mobile">
          <img src={gon.assets[image]} className='product-mockups-mobile' />
        </div>
        <div className="pt-5 p-md-4">
          <div className='step-number-container'>
            <button className={`btn step-number ${active} white mb-3`}>
              {step}
            </button>
          </div>
          <div className="step-header mb-3 text-center">
            <h2>{header}</h2>
          </div>
          <p className="step-body text-center">
            {body}
          </p>
          <div className='mt-5 mb-5'>
            {applyNowButton}
            {talkToExpert}
            {renderButtons('mt-3 btn-line-green w-100')}
          </div>
        </div>
        <div className='progress-icon-container-mobile mb-5'>
          {mobileProgress}
        </div>
      </div>
    }
    </div>
  )
};
export default ApplyStep
